import type { Config, GenericStepData, StepResponse } from '../Onboarder/Config';

export interface StepSummary extends StepResponse {
    link: string;
    hideIfEmpty: boolean;
}

export function createStepSummaries(
    config: Config<GenericStepData>,
    data: GenericStepData
): StepSummary[] {
    const { stepsResponse, steps, basePath } = config;

    return stepsResponse(data).map((summary, index) => {
        const { key, isSkippable } = steps(data)[index];

        return {
            ...summary,
            link: `${basePath}/${index + 1}/${key}`,
            hideIfEmpty: (isSkippable && !summary.answer) || false,
        };
    });
}
